"use client";
import React from "react";
import { HiChevronDoubleUp } from "react-icons/hi";
import useScroll from "./useScroll";

function ScrollToTopButton() {
  const position = useScroll();
  const show = position?.y > 250;
  if (!show) return;
  return (
    <div className="fixed bottom-10 right-5 z-20 md:right-10">
      <button
        className="flex h-[4.5rem] w-[4.5rem] rounded-full bg-secondary-base text-white shadow"
        type="button"
        title="Scroll to Top"
        onClick={() => {
          if (!window) return;
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}
      >
        <HiChevronDoubleUp className="m-auto h-7 w-7" />
      </button>
    </div>
  );
}

export default ScrollToTopButton;
